/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleOAuthAuthorizationData
 */
export interface GoogleOAuthAuthorizationData {
    /**
     * 
     * @type {string}
     * @memberof GoogleOAuthAuthorizationData
     */
    authorizationUrl?: string;
}

/**
 * Check if a given object implements the GoogleOAuthAuthorizationData interface.
 */
export function instanceOfGoogleOAuthAuthorizationData(value: object): value is GoogleOAuthAuthorizationData {
    return true;
}

export function GoogleOAuthAuthorizationDataFromJSON(json: any): GoogleOAuthAuthorizationData {
    return GoogleOAuthAuthorizationDataFromJSONTyped(json, false);
}

export function GoogleOAuthAuthorizationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleOAuthAuthorizationData {
    if (json == null) {
        return json;
    }
    return {
        
        'authorizationUrl': json['authorizationUrl'] == null ? undefined : json['authorizationUrl'],
    };
}

export function GoogleOAuthAuthorizationDataToJSON(json: any): GoogleOAuthAuthorizationData {
    return GoogleOAuthAuthorizationDataToJSONTyped(json, false);
}

export function GoogleOAuthAuthorizationDataToJSONTyped(value?: GoogleOAuthAuthorizationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authorizationUrl': value['authorizationUrl'],
    };
}

